export default {
  type: "Projekt típusa",
  healthProgram: "Egészség program",
  careProgram: "Gondozási program",
  nationalHealthProgram: "Népegészség program",
  progress: "Projekt előrehaladás",
};
